import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation, useMatch, matchRoutes } from "react-router-dom";
import {
  idsCompaniesTrazabilitySection,
  supportedLngs
} from "../utils/ConstCapture";

function useViewControl() {
  const path = window.location.pathname.split("/");
  const pathLanguage = supportedLngs.includes(path[1]) ? path[1] : "es";

  const selectPartsPaths = [
    { path: `/${pathLanguage}/select-parts` },
    { path: `/${pathLanguage}/select-parts/:quantity` },
    { path: `/${pathLanguage}/select-parts/:quantity/:part` },
    {
      path: `/${pathLanguage}/select-parts-tracking`
    }
  ];

  const selectWorkstationPaths = [
    { path: `/${pathLanguage}/workstations` },
    { path: `/${pathLanguage}/workstations/:tab` }
  ];

  const selectMOPaths = [
    { path: `/${pathLanguage}/mo` },
    { path: `/${pathLanguage}/mo/:option` },
    { path: `/${pathLanguage}/mo/:option/:id` }
  ];

  const selectDashboardMOPaths = [{ path: `/${pathLanguage}/dashboard-mo` }];

  const homePaths = [
    { path: `/${pathLanguage}/` },
    { path: `/${pathLanguage}/login` }
  ];

  const [reditect, setRedirect] = useState(null);
  const location = useLocation();
  const matchWorkstationsList = matchRoutes(selectWorkstationPaths, location);
  const matchSelectParts = matchRoutes(selectPartsPaths, location);
  const matchHome = matchRoutes(homePaths, location);
  const matchMo = matchRoutes(selectMOPaths, location);
  const matchDashboardMo = matchRoutes(selectDashboardMOPaths, location);

  const {
    workstationSelected,
    workstation,
    changePart,
    omitPart,
    company,
    data
  } = useSelector(state => ({
    workstationSelected: state.dashboard.workstationSelected,
    workstation: state.dashboard.workstation,
    changePart: state.dashboard.changePart,
    omitPart: state.dashboard.omitPart,
    company: state.userData.company,
    data: state.dashboard.data
  }));
  //workstation.active_part?.id

  const handleRedirect = () => {
    if (!workstationSelected) {
      if (!matchWorkstationsList) {
        return (
          <Navigate
            to={`/${pathLanguage}/workstations/available`}
            replace={true}
          />
        );
      }
    } else if (workstationSelected) {
      const hasActivePart =
        ((workstation?.active_part?.id ||
          workstationSelected?.activated_parts?.length) &&
          (workstation?.use_manufacturing_orders
            ? data?.active_manufactoring_order?.length
            : true)) ||
        omitPart;

			console.log(workstationSelected)
      if (
        workstationSelected?.workstation_type?.type_name === `traceability` ||
        idsCompaniesTrazabilitySection.includes(company?.id)
      ) {
        const workstationServices = workstationSelected?.workstation_services;
        const mainService = workstationServices?.length
          ? workstationServices[0]
          : null;

        if (mainService?.includes(`create_traceability_order`)) {
          if (
            matchWorkstationsList ||
            matchHome ||
            (!matchMo && !matchDashboardMo)
          ) {
            return (
              <Navigate to={`/${pathLanguage}/dashboard-mo`} replace={true} />
            );
          }
        } else if (mainService?.includes(`boarding_outgoing`)) {
          if (changePart) {
            // return <Navigate to={`/select-parts-tracking`} replace={true} />;
            return (
              <Navigate to={`/${pathLanguage}/select-parts`} replace={true} />
            );
          } else if (
            ((matchSelectParts || matchWorkstationsList) && !changePart) ||
            matchHome
          ) {
            return (
              <Navigate
                to={`/${pathLanguage}/dashboard-tracking`}
                replace={true}
              />
            );
          }
        } else if (
          workstationSelected?.workstation_type?.type_name === `checklist`
        ) {
          if (matchSelectParts || matchWorkstationsList || matchHome) {
            return (
              <Navigate to={`/${pathLanguage}/checklists`} replace={true} />
            );
          }
        } else {
          if ((!hasActivePart || changePart) && !matchSelectParts) {
            return (
              <Navigate to={`/${pathLanguage}/select-parts`} replace={true} />
            );
          } else if (
            (hasActivePart &&
              !changePart &&
              (matchSelectParts || matchWorkstationsList)) ||
            matchHome
          ) {
            // return (
            //   <Navigate to={`/${pathLanguage}/dashboard`} replace={true} />
            // );
            return (
              <Navigate to={`/${pathLanguage}/menu-print-tags`} replace={true} />
            );
          }
        }

        // else {
        // if ((!hasActivePart || changePart) && !matchSelectParts) {
        // 	// return <Navigate to={`/select-parts-tracking`} replace={true} />;
        // 	return (
        // 		<Navigate to={`/${pathLanguage}/select-parts`} replace={true} />
        // 	);
        // } else if (
        // 	(hasActivePart &&
        // 		!changePart &&
        // 		(matchSelectParts || matchWorkstationsList)) ||
        // 	matchHome
        // ) {
        // 	return (
        // 		<Navigate
        // 			to={`/${pathLanguage}/menu-print-tags`}
        // 			replace={true}
        // 		/>
        // 	);
        // }
        // }
      } else if (
        workstationSelected?.workstation_type?.type_name === `checklist`
      ) {
        if (matchSelectParts || matchWorkstationsList || matchHome) {
          return <Navigate to={`/${pathLanguage}/checklists`} replace={true} />;
        }
      } else {
        if ((!hasActivePart || changePart) && !matchSelectParts) {
          return (
            <Navigate to={`/${pathLanguage}/select-parts`} replace={true} />
          );
        } else if (
          (hasActivePart &&
            !changePart &&
            (matchSelectParts || matchWorkstationsList)) ||
          matchHome
        ) {
          // console.log("workstation Seletected", workstationSelected);
          // console.log("workstation", workstation);
          // if (workstationSelected?.type_name === "traceability") {
          //   console.log("es de trazabilidad");
          // }
          return <Navigate to={`/${pathLanguage}/dashboard`} replace={true} />;
        }
      }
    }

    console.log("workstation Seletected", workstationSelected);
    console.log("workstation", workstation);
    return;
  };

  useEffect(() => {
    const resp = handleRedirect();
    console.log(resp);
    setRedirect(resp);
  }, [location, workstationSelected, workstation, changePart, omitPart, data]);

  return reditect;
}

export default useViewControl;
